import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  useEffect,
  useMemo,
  useState,
} from "react";

import "./BetPlace.css";

import { db } from "../firebase";

import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";

import { useBalance } from "../context/BalanceContext";

const TIMEZONE = "Africa/Dar_es_Salaam";


// ==========================================
// MULTI-LANGUAGE UI
// Uses the same localStorage language key as the rest of the app.
// Supported codes: en, sw, pt, fr, es, pt-AO, ar, zh, hi, bn, ru, de, it,
// nl, tr, ja, ko, vi, th, id, ms, ur, fa, ha, yo, zu, am, so, rw, lg, af.
// ==========================================
const BETPLACE_TRANSLATIONS = {
  "en": {
    "No Bet Data": "No Bet Data",
    "You Bet": "You Bet",
    "Correct Score": "Correct Score",
    "Against Score": "Against Score",
    "Processing...": "Processing...",
    "Please wait": "Please wait",
    "Bet Placed Successfully": "Bet Placed Successfully",
    "Amount": "Amount",
    "Bet ID": "Bet ID",
    "Match Date": "Match Date",
    "Kick-off Time": "Kick-off Time",
    "Football": "Football",
    "Home": "Home",
    "Loading balance...": "Loading balance...",
    "Please fill in the amount": "Please fill in the amount",
    "Minimum bet": "Minimum bet",
    "for these odds": "for these odds",
    "Profit": "Profit",
    "Gain": "Gain",
    "Balance": "Balance",
    "Loading...": "Loading...",
    "No available balance": "No available balance",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "ALL": "ALL",
    "Amount settings": "Amount settings",
    "No available currency balance": "No available currency balance",
    "Enter valid amount": "Enter valid amount",
    "Invalid odds. Please return and select the bet again.": "Invalid odds. Please return and select the bet again.",
    "Insufficient balance": "Insufficient balance",
    "Minimum bet for": "Minimum bet for",
    "is": "is",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "You have reached the limit of 3 different matches per day. You cannot add a new match today.",
    "Currency field not found": "Currency field not found",
    "Bet failed": "Bet failed",
    "League": "League",
    "OK": "OK",
    "VS": "VS",
    "Username not found": "Username not found",
    "User not found": "User not found",
    "Invalid betting percentage": "Invalid betting percentage"
  },
  "sw": {
    "No Bet Data": "Hakuna taarifa ya dau",
    "You Bet": "Unaweka dau",
    "Correct Score": "Matokeo Sahihi",
    "Against Score": "Matokeo ya Upinzani",
    "Processing...": "Inachakata...",
    "Please wait": "Tafadhali subiri",
    "Bet Placed Successfully": "Dau limewekwa kwa mafanikio",
    "Amount": "Kiasi",
    "Bet ID": "Nambari ya Dau",
    "Match Date": "Tarehe ya Mechi",
    "Kick-off Time": "Muda wa Kuanza",
    "Football": "Soka",
    "Home": "Nyumbani",
    "Loading balance...": "Inapakia salio...",
    "Please fill in the amount": "Tafadhali jaza kiasi",
    "Minimum bet": "Dau la chini",
    "for these odds": "kwa odds hizi",
    "Profit": "Faida",
    "Gain": "Mapato",
    "Balance": "Salio",
    "Loading...": "Inapakia...",
    "No available balance": "Hakuna salio linalopatikana",
    "Cancel": "Ghairi",
    "Confirm": "Thibitisha",
    "ALL": "ZOTE",
    "Amount settings": "Mipangilio ya kiasi",
    "No available currency balance": "Hakuna salio la sarafu linalopatikana",
    "Enter valid amount": "Weka kiasi sahihi",
    "Invalid odds. Please return and select the bet again.": "Odds si sahihi. Tafadhali rudi na uchague dau tena.",
    "Insufficient balance": "Salio halitoshi",
    "Minimum bet for": "Dau la chini kwa",
    "is": "ni",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Umefikia kikomo cha mechi 3 tofauti kwa siku. Huwezi kuongeza mechi mpya leo.",
    "Currency field not found": "Sehemu ya sarafu haikupatikana",
    "Bet failed": "Dau limefeli",
    "League": "Ligi",
    "OK": "Sawa",
    "VS": "DHIDI YA",
    "Username not found": "Jina la mtumiaji halijapatikana",
    "User not found": "Mtumiaji hajapatikana",
    "Invalid betting percentage": "Asilimia ya dau si sahihi"
  },
  "pt": {
    "No Bet Data": "Sem dados da aposta",
    "You Bet": "Você aposta",
    "Correct Score": "Placar exato",
    "Against Score": "Contra placar",
    "Processing...": "Processando...",
    "Please wait": "Aguarde",
    "Bet Placed Successfully": "Aposta realizada com sucesso",
    "Amount": "Valor",
    "Bet ID": "ID da aposta",
    "Match Date": "Data do jogo",
    "Kick-off Time": "Hora de início",
    "Football": "Futebol",
    "Home": "Casa",
    "Loading balance...": "Carregando saldo...",
    "Please fill in the amount": "Informe o valor",
    "Minimum bet": "Aposta mínima",
    "for these odds": "para estas odds",
    "Profit": "Lucro",
    "Gain": "Ganho",
    "Balance": "Saldo",
    "Loading...": "Carregando...",
    "No available balance": "Nenhum saldo disponível",
    "Cancel": "Cancelar",
    "Confirm": "Confirmar",
    "ALL": "TUDO",
    "Amount settings": "Configurações de valor",
    "No available currency balance": "Nenhum saldo de moeda disponível",
    "Enter valid amount": "Informe um valor válido",
    "Invalid odds. Please return and select the bet again.": "Odds inválidas. Volte e selecione a aposta novamente.",
    "Insufficient balance": "Saldo insuficiente",
    "Minimum bet for": "A aposta mínima para",
    "is": "é",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Você atingiu o limite de 3 jogos diferentes por dia. Não pode adicionar outro jogo hoje.",
    "Currency field not found": "Campo da moeda não encontrado",
    "Bet failed": "Falha na aposta",
    "League": "Liga",
    "OK": "OK",
    "VS": "CONTRA",
    "Username not found": "Nome de usuário não encontrado",
    "User not found": "Usuário não encontrado",
    "Invalid betting percentage": "Percentual de aposta inválido"
  },
  "fr": {
    "No Bet Data": "Aucune donnée de pari",
    "You Bet": "Vous pariez",
    "Correct Score": "Score exact",
    "Against Score": "Contre-score",
    "Processing...": "Traitement...",
    "Please wait": "Veuillez patienter",
    "Bet Placed Successfully": "Pari placé avec succès",
    "Amount": "Montant",
    "Bet ID": "ID du pari",
    "Match Date": "Date du match",
    "Kick-off Time": "Heure du coup d’envoi",
    "Football": "Football",
    "Home": "Domicile",
    "Loading balance...": "Chargement du solde...",
    "Please fill in the amount": "Veuillez saisir le montant",
    "Minimum bet": "Pari minimum",
    "for these odds": "pour ces cotes",
    "Profit": "Profit",
    "Gain": "Gain total",
    "Balance": "Solde",
    "Loading...": "Chargement...",
    "No available balance": "Aucun solde disponible",
    "Cancel": "Annuler",
    "Confirm": "Confirmer",
    "ALL": "TOUT",
    "Amount settings": "Paramètres du montant",
    "No available currency balance": "Aucun solde de devise disponible",
    "Enter valid amount": "Saisissez un montant valide",
    "Invalid odds. Please return and select the bet again.": "Cotes invalides. Revenez et sélectionnez à nouveau le pari.",
    "Insufficient balance": "Solde insuffisant",
    "Minimum bet for": "Le pari minimum pour",
    "is": "est",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Vous avez atteint la limite de 3 matchs différents par jour. Vous ne pouvez pas ajouter un nouveau match aujourd’hui.",
    "Currency field not found": "Champ de devise introuvable",
    "Bet failed": "Échec du pari",
    "League": "Ligue",
    "OK": "OK",
    "VS": "CONTRE",
    "Username not found": "Nom d’utilisateur introuvable",
    "User not found": "Utilisateur introuvable",
    "Invalid betting percentage": "Pourcentage de pari invalide"
  },
  "es": {
    "No Bet Data": "No hay datos de apuesta",
    "You Bet": "Tu apuesta",
    "Correct Score": "Marcador exacto",
    "Against Score": "Contra marcador",
    "Processing...": "Procesando...",
    "Please wait": "Por favor, espera",
    "Bet Placed Successfully": "Apuesta realizada correctamente",
    "Amount": "Cantidad",
    "Bet ID": "ID de apuesta",
    "Match Date": "Fecha del partido",
    "Kick-off Time": "Hora de inicio",
    "Football": "Fútbol",
    "Home": "Local",
    "Loading balance...": "Cargando saldo...",
    "Please fill in the amount": "Introduce la cantidad",
    "Minimum bet": "Apuesta mínima",
    "for these odds": "para estas cuotas",
    "Profit": "Beneficio",
    "Gain": "Ganancia",
    "Balance": "Saldo",
    "Loading...": "Cargando...",
    "No available balance": "No hay saldo disponible",
    "Cancel": "Cancelar",
    "Confirm": "Confirmar",
    "ALL": "TODO",
    "Amount settings": "Configuración de cantidad",
    "No available currency balance": "No hay saldo de moneda disponible",
    "Enter valid amount": "Introduce una cantidad válida",
    "Invalid odds. Please return and select the bet again.": "Cuotas no válidas. Vuelve y selecciona la apuesta otra vez.",
    "Insufficient balance": "Saldo insuficiente",
    "Minimum bet for": "La apuesta mínima para",
    "is": "es",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Has alcanzado el límite de 3 partidos diferentes al día. No puedes añadir otro partido hoy.",
    "Currency field not found": "No se encontró el campo de moneda",
    "Bet failed": "Apuesta fallida",
    "League": "Liga",
    "OK": "OK",
    "VS": "CONTRA",
    "Username not found": "Usuario no encontrado",
    "User not found": "Usuario no encontrado",
    "Invalid betting percentage": "Porcentaje de apuesta no válido"
  },
  "pt-AO": {
    "No Bet Data": "Sem dados da aposta",
    "You Bet": "Você aposta",
    "Correct Score": "Placar exato",
    "Against Score": "Contra placar",
    "Processing...": "Processando...",
    "Please wait": "Aguarde",
    "Bet Placed Successfully": "Aposta realizada com sucesso",
    "Amount": "Valor",
    "Bet ID": "ID da aposta",
    "Match Date": "Data do jogo",
    "Kick-off Time": "Hora de início",
    "Football": "Futebol",
    "Home": "Casa",
    "Loading balance...": "Carregando saldo...",
    "Please fill in the amount": "Informe o valor",
    "Minimum bet": "Aposta mínima",
    "for these odds": "para estas odds",
    "Profit": "Lucro",
    "Gain": "Ganho",
    "Balance": "Saldo",
    "Loading...": "Carregando...",
    "No available balance": "Nenhum saldo disponível",
    "Cancel": "Cancelar",
    "Confirm": "Confirmar",
    "ALL": "TUDO",
    "Amount settings": "Configurações de valor",
    "No available currency balance": "Nenhum saldo de moeda disponível",
    "Enter valid amount": "Informe um valor válido",
    "Invalid odds. Please return and select the bet again.": "Odds inválidas. Volte e selecione a aposta novamente.",
    "Insufficient balance": "Saldo insuficiente",
    "Minimum bet for": "A aposta mínima para",
    "is": "é",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Você atingiu o limite de 3 jogos diferentes por dia. Não pode adicionar outro jogo hoje.",
    "Currency field not found": "Campo da moeda não encontrado",
    "Bet failed": "Falha na aposta",
    "League": "Liga",
    "OK": "OK",
    "VS": "CONTRA",
    "Username not found": "Nome de utilizador não encontrado",
    "User not found": "Utilizador não encontrado",
    "Invalid betting percentage": "Percentagem de aposta inválida"
  },
  "ar": {
    "No Bet Data": "لا توجد بيانات رهان",
    "You Bet": "رهانك",
    "Correct Score": "النتيجة الصحيحة",
    "Against Score": "ضد النتيجة",
    "Processing...": "جارٍ المعالجة...",
    "Please wait": "يرجى الانتظار",
    "Bet Placed Successfully": "تم وضع الرهان بنجاح",
    "Amount": "المبلغ",
    "Bet ID": "معرّف الرهان",
    "Match Date": "تاريخ المباراة",
    "Kick-off Time": "وقت البداية",
    "Football": "كرة القدم",
    "Home": "الفريق المضيف",
    "Loading balance...": "جارٍ تحميل الرصيد...",
    "Please fill in the amount": "يرجى إدخال المبلغ",
    "Minimum bet": "الحد الأدنى للرهان",
    "for these odds": "لهذه الاحتمالات",
    "Profit": "الربح",
    "Gain": "المكسب",
    "Balance": "الرصيد",
    "Loading...": "جارٍ التحميل...",
    "No available balance": "لا يوجد رصيد متاح",
    "Cancel": "إلغاء",
    "Confirm": "تأكيد",
    "ALL": "الكل",
    "Amount settings": "إعدادات المبلغ",
    "No available currency balance": "لا يوجد رصيد عملة متاح",
    "Enter valid amount": "أدخل مبلغًا صالحًا",
    "Invalid odds. Please return and select the bet again.": "احتمالات غير صالحة. ارجع واختر الرهان مرة أخرى.",
    "Insufficient balance": "الرصيد غير كافٍ",
    "Minimum bet for": "الحد الأدنى للرهان لـ",
    "is": "هو",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "لقد وصلت إلى حد 3 مباريات مختلفة يوميًا. لا يمكنك إضافة مباراة جديدة اليوم.",
    "Currency field not found": "لم يتم العثور على حقل العملة",
    "Bet failed": "فشل الرهان",
    "League": "الدوري",
    "OK": "حسنًا",
    "VS": "ضد",
    "Username not found": "اسم المستخدم غير موجود",
    "User not found": "المستخدم غير موجود",
    "Invalid betting percentage": "نسبة الرهان غير صالحة"
  },
  "zh": {
    "No Bet Data": "没有投注数据",
    "You Bet": "你的投注",
    "Correct Score": "正确比分",
    "Against Score": "对抗比分",
    "Processing...": "处理中...",
    "Please wait": "请稍候",
    "Bet Placed Successfully": "投注成功",
    "Amount": "金额",
    "Bet ID": "投注编号",
    "Match Date": "比赛日期",
    "Kick-off Time": "开球时间",
    "Football": "足球",
    "Home": "主场",
    "Loading balance...": "正在加载余额...",
    "Please fill in the amount": "请输入金额",
    "Minimum bet": "最低投注额",
    "for these odds": "适用于这些赔率",
    "Profit": "利润",
    "Gain": "总收益",
    "Balance": "余额",
    "Loading...": "加载中...",
    "No available balance": "没有可用余额",
    "Cancel": "取消",
    "Confirm": "确认",
    "ALL": "全部",
    "Amount settings": "金额设置",
    "No available currency balance": "没有可用货币余额",
    "Enter valid amount": "请输入有效金额",
    "Invalid odds. Please return and select the bet again.": "赔率无效。请返回并重新选择投注。",
    "Insufficient balance": "余额不足",
    "Minimum bet for": "最低投注额（",
    "is": "）为",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "您已达到每天 3 场不同比赛的限制，今天不能添加新比赛。",
    "Currency field not found": "未找到货币字段",
    "Bet failed": "投注失败",
    "League": "联赛",
    "OK": "确定",
    "VS": "对阵",
    "Username not found": "未找到用户名",
    "User not found": "未找到用户",
    "Invalid betting percentage": "投注百分比无效"
  },
  "hi": {
    "No Bet Data": "कोई बेट डेटा नहीं",
    "You Bet": "आपकी बेट",
    "Correct Score": "सही स्कोर",
    "Against Score": "विपरीत स्कोर",
    "Processing...": "प्रोसेस हो रहा है...",
    "Please wait": "कृपया प्रतीक्षा करें",
    "Bet Placed Successfully": "बेट सफलतापूर्वक लगाई गई",
    "Amount": "राशि",
    "Bet ID": "बेट आईडी",
    "Match Date": "मैच की तारीख",
    "Kick-off Time": "किक-ऑफ समय",
    "Football": "फ़ुटबॉल",
    "Home": "होम",
    "Loading balance...": "बैलेंस लोड हो रहा है...",
    "Please fill in the amount": "राशि भरें",
    "Minimum bet": "न्यूनतम बेट",
    "for these odds": "इन ऑड्स के लिए",
    "Profit": "लाभ",
    "Gain": "कुल जीत",
    "Balance": "बैलेंस",
    "Loading...": "लोड हो रहा है...",
    "No available balance": "कोई उपलब्ध बैलेंस नहीं",
    "Cancel": "रद्द करें",
    "Confirm": "पुष्टि करें",
    "ALL": "सभी",
    "Amount settings": "राशि सेटिंग्स",
    "No available currency balance": "कोई उपलब्ध मुद्रा बैलेंस नहीं",
    "Enter valid amount": "मान्य राशि दर्ज करें",
    "Invalid odds. Please return and select the bet again.": "ऑड्स अमान्य हैं। वापस जाकर बेट फिर चुनें।",
    "Insufficient balance": "अपर्याप्त बैलेंस",
    "Minimum bet for": "के लिए न्यूनतम बेट",
    "is": "है",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "आपने प्रतिदिन 3 अलग-अलग मैचों की सीमा पूरी कर ली है। आज नया मैच नहीं जोड़ सकते।",
    "Currency field not found": "मुद्रा फ़ील्ड नहीं मिला",
    "Bet failed": "बेट विफल",
    "League": "लीग",
    "OK": "ठीक है",
    "VS": "बनाम",
    "Username not found": "उपयोगकर्ता नाम नहीं मिला",
    "User not found": "उपयोगकर्ता नहीं मिला",
    "Invalid betting percentage": "बेट प्रतिशत अमान्य है"
  },
  "bn": {
    "No Bet Data": "কোনো বেটের তথ্য নেই",
    "You Bet": "আপনার বেট",
    "Correct Score": "সঠিক স্কোর",
    "Against Score": "বিপরীত স্কোর",
    "Processing...": "প্রক্রিয়াকরণ হচ্ছে...",
    "Please wait": "অনুগ্রহ করে অপেক্ষা করুন",
    "Bet Placed Successfully": "বেট সফলভাবে দেওয়া হয়েছে",
    "Amount": "পরিমাণ",
    "Bet ID": "বেট আইডি",
    "Match Date": "ম্যাচের তারিখ",
    "Kick-off Time": "শুরুর সময়",
    "Football": "ফুটবল",
    "Home": "হোম",
    "Loading balance...": "ব্যালেন্স লোড হচ্ছে...",
    "Please fill in the amount": "পরিমাণ লিখুন",
    "Minimum bet": "সর্বনিম্ন বেট",
    "for these odds": "এই অডসের জন্য",
    "Profit": "লাভ",
    "Gain": "মোট জয়",
    "Balance": "ব্যালেন্স",
    "Loading...": "লোড হচ্ছে...",
    "No available balance": "কোনো ব্যালেন্স নেই",
    "Cancel": "বাতিল",
    "Confirm": "নিশ্চিত করুন",
    "ALL": "সব",
    "Amount settings": "পরিমাণ সেটিংস",
    "No available currency balance": "কোনো মুদ্রার ব্যালেন্স নেই",
    "Enter valid amount": "সঠিক পরিমাণ লিখুন",
    "Invalid odds. Please return and select the bet again.": "অডস ভুল। ফিরে গিয়ে আবার বেট নির্বাচন করুন।",
    "Insufficient balance": "পর্যাপ্ত ব্যালেন্স নেই",
    "Minimum bet for": "এর সর্বনিম্ন বেট",
    "is": "হলো",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "আপনি দিনে ৩টি ভিন্ন ম্যাচের সীমায় পৌঁছেছেন। আজ নতুন ম্যাচ যোগ করা যাবে না।",
    "Currency field not found": "মুদ্রার ফিল্ড পাওয়া যায়নি",
    "Bet failed": "বেট ব্যর্থ",
    "League": "লিগ",
    "OK": "ঠিক আছে",
    "VS": "বনাম",
    "Username not found": "ব্যবহারকারীর নাম পাওয়া যায়নি",
    "User not found": "ব্যবহারকারী পাওয়া যায়নি",
    "Invalid betting percentage": "বেটের শতাংশ সঠিক নয়"
  },
  "ru": {
    "No Bet Data": "Нет данных о ставке",
    "You Bet": "Ваша ставка",
    "Correct Score": "Точный счёт",
    "Against Score": "Против счёта",
    "Processing...": "Обработка...",
    "Please wait": "Пожалуйста, подождите",
    "Bet Placed Successfully": "Ставка успешно размещена",
    "Amount": "Сумма",
    "Bet ID": "ID ставки",
    "Match Date": "Дата матча",
    "Kick-off Time": "Время начала",
    "Football": "Футбол",
    "Home": "Хозяева",
    "Loading balance...": "Загрузка баланса...",
    "Please fill in the amount": "Введите сумму",
    "Minimum bet": "Минимальная ставка",
    "for these odds": "для этих коэффициентов",
    "Profit": "Прибыль",
    "Gain": "Выигрыш",
    "Balance": "Баланс",
    "Loading...": "Загрузка...",
    "No available balance": "Нет доступного баланса",
    "Cancel": "Отмена",
    "Confirm": "Подтвердить",
    "ALL": "ВСЁ",
    "Amount settings": "Настройки суммы",
    "No available currency balance": "Нет доступного баланса валюты",
    "Enter valid amount": "Введите корректную сумму",
    "Invalid odds. Please return and select the bet again.": "Неверные коэффициенты. Вернитесь и выберите ставку снова.",
    "Insufficient balance": "Недостаточно средств",
    "Minimum bet for": "Минимальная ставка для",
    "is": "—",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Вы достигли лимита в 3 разных матча в день. Сегодня нельзя добавить новый матч.",
    "Currency field not found": "Поле валюты не найдено",
    "Bet failed": "Ставка не удалась",
    "League": "Лига",
    "OK": "ОК",
    "VS": "ПРОТИВ",
    "Username not found": "Имя пользователя не найдено",
    "User not found": "Пользователь не найден",
    "Invalid betting percentage": "Недопустимый процент ставки"
  },
  "de": {
    "No Bet Data": "Keine Wettinformationen",
    "You Bet": "Dein Einsatz",
    "Correct Score": "Korrektes Ergebnis",
    "Against Score": "Gegenergebnis",
    "Processing...": "Wird verarbeitet...",
    "Please wait": "Bitte warten",
    "Bet Placed Successfully": "Wette erfolgreich platziert",
    "Amount": "Betrag",
    "Bet ID": "Wett-ID",
    "Match Date": "Spieldatum",
    "Kick-off Time": "Anstoßzeit",
    "Football": "Fußball",
    "Home": "Heim",
    "Loading balance...": "Kontostand wird geladen...",
    "Please fill in the amount": "Bitte Betrag eingeben",
    "Minimum bet": "Mindesteinsatz",
    "for these odds": "für diese Quoten",
    "Profit": "Gewinn",
    "Gain": "Gesamtgewinn",
    "Balance": "Kontostand",
    "Loading...": "Wird geladen...",
    "No available balance": "Kein verfügbares Guthaben",
    "Cancel": "Abbrechen",
    "Confirm": "Bestätigen",
    "ALL": "ALLE",
    "Amount settings": "Betragseinstellungen",
    "No available currency balance": "Kein verfügbares Währungsguthaben",
    "Enter valid amount": "Gültigen Betrag eingeben",
    "Invalid odds. Please return and select the bet again.": "Ungültige Quoten. Bitte zurückgehen und die Wette erneut auswählen.",
    "Insufficient balance": "Unzureichendes Guthaben",
    "Minimum bet for": "Mindesteinsatz für",
    "is": "ist",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Du hast das Limit von 3 verschiedenen Spielen pro Tag erreicht. Heute kannst du kein neues Spiel hinzufügen.",
    "Currency field not found": "Währungsfeld nicht gefunden",
    "Bet failed": "Wette fehlgeschlagen",
    "League": "Liga",
    "OK": "OK",
    "VS": "GEGEN",
    "Username not found": "Benutzername nicht gefunden",
    "User not found": "Benutzer nicht gefunden",
    "Invalid betting percentage": "Ungültiger Wettprozentsatz"
  },
  "it": {
    "No Bet Data": "Nessun dato della scommessa",
    "You Bet": "La tua scommessa",
    "Correct Score": "Risultato esatto",
    "Against Score": "Contro risultato",
    "Processing...": "Elaborazione...",
    "Please wait": "Attendere prego",
    "Bet Placed Successfully": "Scommessa piazzata con successo",
    "Amount": "Importo",
    "Bet ID": "ID scommessa",
    "Match Date": "Data della partita",
    "Kick-off Time": "Ora d’inizio",
    "Football": "Calcio",
    "Home": "Casa",
    "Loading balance...": "Caricamento saldo...",
    "Please fill in the amount": "Inserisci l’importo",
    "Minimum bet": "Puntata minima",
    "for these odds": "per queste quote",
    "Profit": "Profitto",
    "Gain": "Vincita",
    "Balance": "Saldo",
    "Loading...": "Caricamento...",
    "No available balance": "Nessun saldo disponibile",
    "Cancel": "Annulla",
    "Confirm": "Conferma",
    "ALL": "TUTTO",
    "Amount settings": "Impostazioni importo",
    "No available currency balance": "Nessun saldo valuta disponibile",
    "Enter valid amount": "Inserisci un importo valido",
    "Invalid odds. Please return and select the bet again.": "Quote non valide. Torna indietro e seleziona di nuovo la scommessa.",
    "Insufficient balance": "Saldo insufficiente",
    "Minimum bet for": "La puntata minima per",
    "is": "è",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Hai raggiunto il limite di 3 partite diverse al giorno. Non puoi aggiungerne un’altra oggi.",
    "Currency field not found": "Campo valuta non trovato",
    "Bet failed": "Scommessa non riuscita",
    "League": "Lega",
    "OK": "OK",
    "VS": "CONTRO",
    "Username not found": "Nome utente non trovato",
    "User not found": "Utente non trovato",
    "Invalid betting percentage": "Percentuale di scommessa non valida"
  },
  "nl": {
    "No Bet Data": "Geen wedgegevens",
    "You Bet": "Je inzet",
    "Correct Score": "Juiste score",
    "Against Score": "Tegenscore",
    "Processing...": "Verwerken...",
    "Please wait": "Even geduld",
    "Bet Placed Successfully": "Wedstrijd succesvol ingezet",
    "Amount": "Bedrag",
    "Bet ID": "Wed-ID",
    "Match Date": "Wedstrijddatum",
    "Kick-off Time": "Aftraptijd",
    "Football": "Voetbal",
    "Home": "Thuis",
    "Loading balance...": "Saldo laden...",
    "Please fill in the amount": "Vul het bedrag in",
    "Minimum bet": "Minimuminzet",
    "for these odds": "voor deze odds",
    "Profit": "Winst",
    "Gain": "Totale winst",
    "Balance": "Saldo",
    "Loading...": "Laden...",
    "No available balance": "Geen beschikbaar saldo",
    "Cancel": "Annuleren",
    "Confirm": "Bevestigen",
    "ALL": "ALLES",
    "Amount settings": "Bedraginstellingen",
    "No available currency balance": "Geen beschikbaar valutasaldo",
    "Enter valid amount": "Voer een geldig bedrag in",
    "Invalid odds. Please return and select the bet again.": "Ongeldige odds. Ga terug en selecteer de weddenschap opnieuw.",
    "Insufficient balance": "Onvoldoende saldo",
    "Minimum bet for": "Minimuminzet voor",
    "is": "is",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Je hebt de limiet van 3 verschillende wedstrijden per dag bereikt. Je kunt vandaag geen nieuwe wedstrijd toevoegen.",
    "Currency field not found": "Valutaveld niet gevonden",
    "Bet failed": "Wedstrijd mislukt",
    "League": "Competitie",
    "OK": "OK",
    "VS": "TEGEN",
    "Username not found": "Gebruikersnaam niet gevonden",
    "User not found": "Gebruiker niet gevonden",
    "Invalid betting percentage": "Ongeldig inzetpercentage"
  },
  "tr": {
    "No Bet Data": "Bahis verisi yok",
    "You Bet": "Bahsiniz",
    "Correct Score": "Doğru skor",
    "Against Score": "Karşı skor",
    "Processing...": "İşleniyor...",
    "Please wait": "Lütfen bekleyin",
    "Bet Placed Successfully": "Bahis başarıyla yapıldı",
    "Amount": "Tutar",
    "Bet ID": "Bahis kimliği",
    "Match Date": "Maç tarihi",
    "Kick-off Time": "Başlama saati",
    "Football": "Futbol",
    "Home": "Ev sahibi",
    "Loading balance...": "Bakiye yükleniyor...",
    "Please fill in the amount": "Lütfen tutarı girin",
    "Minimum bet": "Minimum bahis",
    "for these odds": "bu oranlar için",
    "Profit": "Kâr",
    "Gain": "Kazanç",
    "Balance": "Bakiye",
    "Loading...": "Yükleniyor...",
    "No available balance": "Kullanılabilir bakiye yok",
    "Cancel": "İptal",
    "Confirm": "Onayla",
    "ALL": "TÜMÜ",
    "Amount settings": "Tutar ayarları",
    "No available currency balance": "Kullanılabilir para birimi bakiyesi yok",
    "Enter valid amount": "Geçerli bir tutar girin",
    "Invalid odds. Please return and select the bet again.": "Oranlar geçersiz. Geri dönüp bahsi yeniden seçin.",
    "Insufficient balance": "Yetersiz bakiye",
    "Minimum bet for": "Minimum bahis tutarı",
    "is": "şudur",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Günlük 3 farklı maç sınırına ulaştınız. Bugün yeni maç ekleyemezsiniz.",
    "Currency field not found": "Para birimi alanı bulunamadı",
    "Bet failed": "Bahis başarısız",
    "League": "Lig",
    "OK": "Tamam",
    "VS": "KARŞI",
    "Username not found": "Kullanıcı adı bulunamadı",
    "User not found": "Kullanıcı bulunamadı",
    "Invalid betting percentage": "Geçersiz bahis yüzdesi"
  },
  "ja": {
    "No Bet Data": "ベットデータがありません",
    "You Bet": "あなたのベット",
    "Correct Score": "正確なスコア",
    "Against Score": "対抗スコア",
    "Processing...": "処理中...",
    "Please wait": "お待ちください",
    "Bet Placed Successfully": "ベットが正常に成立しました",
    "Amount": "金額",
    "Bet ID": "ベットID",
    "Match Date": "試合日",
    "Kick-off Time": "キックオフ時刻",
    "Football": "サッカー",
    "Home": "ホーム",
    "Loading balance...": "残高を読み込み中...",
    "Please fill in the amount": "金額を入力してください",
    "Minimum bet": "最低ベット額",
    "for these odds": "このオッズの場合",
    "Profit": "利益",
    "Gain": "獲得額",
    "Balance": "残高",
    "Loading...": "読み込み中...",
    "No available balance": "利用可能な残高がありません",
    "Cancel": "キャンセル",
    "Confirm": "確認",
    "ALL": "すべて",
    "Amount settings": "金額設定",
    "No available currency balance": "利用可能な通貨残高がありません",
    "Enter valid amount": "有効な金額を入力してください",
    "Invalid odds. Please return and select the bet again.": "オッズが無効です。戻ってベットを選び直してください。",
    "Insufficient balance": "残高不足",
    "Minimum bet for": "最低ベット額：",
    "is": "です",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "1日に異なる試合を3つまでという制限に達しました。今日は新しい試合を追加できません。",
    "Currency field not found": "通貨フィールドが見つかりません",
    "Bet failed": "ベットに失敗しました",
    "League": "リーグ",
    "OK": "OK",
    "VS": "対",
    "Username not found": "ユーザー名が見つかりません",
    "User not found": "ユーザーが見つかりません",
    "Invalid betting percentage": "賭け率が無効です"
  },
  "ko": {
    "No Bet Data": "베팅 데이터가 없습니다",
    "You Bet": "베팅하기",
    "Correct Score": "정확한 점수",
    "Against Score": "반대 점수",
    "Processing...": "처리 중...",
    "Please wait": "잠시 기다려 주세요",
    "Bet Placed Successfully": "베팅이 성공적으로 완료되었습니다",
    "Amount": "금액",
    "Bet ID": "베팅 ID",
    "Match Date": "경기 날짜",
    "Kick-off Time": "킥오프 시간",
    "Football": "축구",
    "Home": "홈",
    "Loading balance...": "잔액 불러오는 중...",
    "Please fill in the amount": "금액을 입력하세요",
    "Minimum bet": "최소 베팅",
    "for these odds": "이 배당률 기준",
    "Profit": "수익",
    "Gain": "총 당첨금",
    "Balance": "잔액",
    "Loading...": "불러오는 중...",
    "No available balance": "사용 가능한 잔액이 없습니다",
    "Cancel": "취소",
    "Confirm": "확인",
    "ALL": "전체",
    "Amount settings": "금액 설정",
    "No available currency balance": "사용 가능한 통화 잔액이 없습니다",
    "Enter valid amount": "유효한 금액을 입력하세요",
    "Invalid odds. Please return and select the bet again.": "배당률이 잘못되었습니다. 돌아가서 다시 선택하세요.",
    "Insufficient balance": "잔액 부족",
    "Minimum bet for": "최소 베팅 금액:",
    "is": "입니다",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "하루에 서로 다른 경기 3개 제한에 도달했습니다. 오늘은 새 경기를 추가할 수 없습니다.",
    "Currency field not found": "통화 필드를 찾을 수 없습니다",
    "Bet failed": "베팅 실패",
    "League": "리그",
    "OK": "확인",
    "VS": "대",
    "Username not found": "사용자 이름을 찾을 수 없습니다",
    "User not found": "사용자를 찾을 수 없습니다",
    "Invalid betting percentage": "베팅 비율이 잘못되었습니다"
  },
  "vi": {
    "No Bet Data": "Không có dữ liệu cược",
    "You Bet": "Bạn cược",
    "Correct Score": "Tỷ số chính xác",
    "Against Score": "Đối tỷ số",
    "Processing...": "Đang xử lý...",
    "Please wait": "Vui lòng chờ",
    "Bet Placed Successfully": "Đặt cược thành công",
    "Amount": "Số tiền",
    "Bet ID": "Mã cược",
    "Match Date": "Ngày thi đấu",
    "Kick-off Time": "Giờ bắt đầu",
    "Football": "Bóng đá",
    "Home": "Sân nhà",
    "Loading balance...": "Đang tải số dư...",
    "Please fill in the amount": "Vui lòng nhập số tiền",
    "Minimum bet": "Cược tối thiểu",
    "for these odds": "cho tỷ lệ này",
    "Profit": "Lợi nhuận",
    "Gain": "Tiền thắng",
    "Balance": "Số dư",
    "Loading...": "Đang tải...",
    "No available balance": "Không có số dư khả dụng",
    "Cancel": "Hủy",
    "Confirm": "Xác nhận",
    "ALL": "TẤT CẢ",
    "Amount settings": "Cài đặt số tiền",
    "No available currency balance": "Không có số dư tiền tệ khả dụng",
    "Enter valid amount": "Nhập số tiền hợp lệ",
    "Invalid odds. Please return and select the bet again.": "Tỷ lệ cược không hợp lệ. Vui lòng quay lại và chọn lại cược.",
    "Insufficient balance": "Số dư không đủ",
    "Minimum bet for": "Cược tối thiểu cho",
    "is": "là",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Bạn đã đạt giới hạn 3 trận khác nhau mỗi ngày. Hôm nay không thể thêm trận mới.",
    "Currency field not found": "Không tìm thấy trường tiền tệ",
    "Bet failed": "Cược thất bại",
    "League": "Giải đấu",
    "OK": "OK",
    "VS": "ĐỐI ĐẦU",
    "Username not found": "Không tìm thấy tên người dùng",
    "User not found": "Không tìm thấy người dùng",
    "Invalid betting percentage": "Phần trăm cược không hợp lệ"
  },
  "th": {
    "No Bet Data": "ไม่มีข้อมูลการเดิมพัน",
    "You Bet": "คุณเดิมพัน",
    "Correct Score": "สกอร์ที่ถูกต้อง",
    "Against Score": "สกอร์ตรงข้าม",
    "Processing...": "กำลังดำเนินการ...",
    "Please wait": "โปรดรอสักครู่",
    "Bet Placed Successfully": "วางเดิมพันสำเร็จ",
    "Amount": "จำนวนเงิน",
    "Bet ID": "รหัสเดิมพัน",
    "Match Date": "วันที่แข่งขัน",
    "Kick-off Time": "เวลาเริ่มแข่ง",
    "Football": "ฟุตบอล",
    "Home": "เจ้าบ้าน",
    "Loading balance...": "กำลังโหลดยอดเงิน...",
    "Please fill in the amount": "กรอกจำนวนเงิน",
    "Minimum bet": "เดิมพันขั้นต่ำ",
    "for these odds": "สำหรับอัตราต่อรองนี้",
    "Profit": "กำไร",
    "Gain": "ยอดรับ",
    "Balance": "ยอดเงิน",
    "Loading...": "กำลังโหลด...",
    "No available balance": "ไม่มียอดเงินที่ใช้ได้",
    "Cancel": "ยกเลิก",
    "Confirm": "ยืนยัน",
    "ALL": "ทั้งหมด",
    "Amount settings": "ตั้งค่าจำนวนเงิน",
    "No available currency balance": "ไม่มียอดเงินสกุลที่ใช้ได้",
    "Enter valid amount": "กรอกจำนวนเงินที่ถูกต้อง",
    "Invalid odds. Please return and select the bet again.": "อัตราต่อรองไม่ถูกต้อง โปรดกลับไปเลือกเดิมพันใหม่",
    "Insufficient balance": "ยอดเงินไม่เพียงพอ",
    "Minimum bet for": "เดิมพันขั้นต่ำสำหรับ",
    "is": "คือ",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "คุณถึงขีดจำกัด 3 แมตช์ที่แตกต่างกันต่อวันแล้ว วันนี้ไม่สามารถเพิ่มแมตช์ใหม่ได้",
    "Currency field not found": "ไม่พบฟิลด์สกุลเงิน",
    "Bet failed": "เดิมพันไม่สำเร็จ",
    "League": "ลีก",
    "OK": "ตกลง",
    "VS": "พบกับ",
    "Username not found": "ไม่พบชื่อผู้ใช้",
    "User not found": "ไม่พบผู้ใช้",
    "Invalid betting percentage": "เปอร์เซ็นต์การเดิมพันไม่ถูกต้อง"
  },
  "id": {
    "No Bet Data": "Tidak ada data taruhan",
    "You Bet": "Taruhan Anda",
    "Correct Score": "Skor tepat",
    "Against Score": "Lawan skor",
    "Processing...": "Memproses...",
    "Please wait": "Silakan tunggu",
    "Bet Placed Successfully": "Taruhan berhasil dipasang",
    "Amount": "Jumlah",
    "Bet ID": "ID taruhan",
    "Match Date": "Tanggal pertandingan",
    "Kick-off Time": "Waktu mulai",
    "Football": "Sepak bola",
    "Home": "Kandang",
    "Loading balance...": "Memuat saldo...",
    "Please fill in the amount": "Masukkan jumlah",
    "Minimum bet": "Taruhan minimum",
    "for these odds": "untuk odds ini",
    "Profit": "Keuntungan",
    "Gain": "Total kemenangan",
    "Balance": "Saldo",
    "Loading...": "Memuat...",
    "No available balance": "Tidak ada saldo tersedia",
    "Cancel": "Batal",
    "Confirm": "Konfirmasi",
    "ALL": "SEMUA",
    "Amount settings": "Pengaturan jumlah",
    "No available currency balance": "Tidak ada saldo mata uang tersedia",
    "Enter valid amount": "Masukkan jumlah yang valid",
    "Invalid odds. Please return and select the bet again.": "Odds tidak valid. Kembali dan pilih taruhan lagi.",
    "Insufficient balance": "Saldo tidak cukup",
    "Minimum bet for": "Taruhan minimum untuk",
    "is": "adalah",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Anda mencapai batas 3 pertandingan berbeda per hari. Anda tidak dapat menambahkan pertandingan baru hari ini.",
    "Currency field not found": "Kolom mata uang tidak ditemukan",
    "Bet failed": "Taruhan gagal",
    "League": "Liga",
    "OK": "OK",
    "VS": "LAWAN",
    "Username not found": "Nama pengguna tidak ditemukan",
    "User not found": "Pengguna tidak ditemukan",
    "Invalid betting percentage": "Persentase taruhan tidak valid"
  },
  "ms": {
    "No Bet Data": "Tiada data pertaruhan",
    "You Bet": "Pertaruhan anda",
    "Correct Score": "Skor tepat",
    "Against Score": "Skor lawan",
    "Processing...": "Sedang diproses...",
    "Please wait": "Sila tunggu",
    "Bet Placed Successfully": "Pertaruhan berjaya dibuat",
    "Amount": "Jumlah",
    "Bet ID": "ID pertaruhan",
    "Match Date": "Tarikh perlawanan",
    "Kick-off Time": "Masa sepak mula",
    "Football": "Bola sepak",
    "Home": "Tuan rumah",
    "Loading balance...": "Memuatkan baki...",
    "Please fill in the amount": "Sila masukkan jumlah",
    "Minimum bet": "Pertaruhan minimum",
    "for these odds": "untuk odds ini",
    "Profit": "Keuntungan",
    "Gain": "Jumlah kemenangan",
    "Balance": "Baki",
    "Loading...": "Memuatkan...",
    "No available balance": "Tiada baki tersedia",
    "Cancel": "Batal",
    "Confirm": "Sahkan",
    "ALL": "SEMUA",
    "Amount settings": "Tetapan jumlah",
    "No available currency balance": "Tiada baki mata wang tersedia",
    "Enter valid amount": "Masukkan jumlah yang sah",
    "Invalid odds. Please return and select the bet again.": "Odds tidak sah. Kembali dan pilih pertaruhan sekali lagi.",
    "Insufficient balance": "Baki tidak mencukupi",
    "Minimum bet for": "Pertaruhan minimum untuk",
    "is": "ialah",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Anda telah mencapai had 3 perlawanan berbeza sehari. Anda tidak boleh menambah perlawanan baharu hari ini.",
    "Currency field not found": "Medan mata wang tidak ditemui",
    "Bet failed": "Pertaruhan gagal",
    "League": "Liga",
    "OK": "OK",
    "VS": "LWN",
    "Username not found": "Nama pengguna tidak ditemui",
    "User not found": "Pengguna tidak ditemui",
    "Invalid betting percentage": "Peratus pertaruhan tidak sah"
  },
  "ur": {
    "No Bet Data": "بیٹنگ کا ڈیٹا موجود نہیں",
    "You Bet": "آپ کی شرط",
    "Correct Score": "درست اسکور",
    "Against Score": "مخالف اسکور",
    "Processing...": "عمل جاری ہے...",
    "Please wait": "براہ کرم انتظار کریں",
    "Bet Placed Successfully": "شرط کامیابی سے لگ گئی",
    "Amount": "رقم",
    "Bet ID": "شرط کی شناخت",
    "Match Date": "میچ کی تاریخ",
    "Kick-off Time": "شروع ہونے کا وقت",
    "Football": "فٹ بال",
    "Home": "ہوم",
    "Loading balance...": "بیلنس لوڈ ہو رہا ہے...",
    "Please fill in the amount": "رقم درج کریں",
    "Minimum bet": "کم از کم شرط",
    "for these odds": "ان odds کے لیے",
    "Profit": "منافع",
    "Gain": "کل جیت",
    "Balance": "بیلنس",
    "Loading...": "لوڈ ہو رہا ہے...",
    "No available balance": "کوئی دستیاب بیلنس نہیں",
    "Cancel": "منسوخ",
    "Confirm": "تصدیق کریں",
    "ALL": "سب",
    "Amount settings": "رقم کی ترتیبات",
    "No available currency balance": "کرنسی کا کوئی دستیاب بیلنس نہیں",
    "Enter valid amount": "درست رقم درج کریں",
    "Invalid odds. Please return and select the bet again.": "Odds غلط ہیں۔ واپس جا کر شرط دوبارہ منتخب کریں۔",
    "Insufficient balance": "بیلنس ناکافی ہے",
    "Minimum bet for": "کم از کم شرط",
    "is": "ہے",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "آپ روزانہ 3 مختلف میچوں کی حد تک پہنچ گئے ہیں۔ آج نیا میچ شامل نہیں کر سکتے۔",
    "Currency field not found": "کرنسی فیلڈ نہیں ملا",
    "Bet failed": "شرط ناکام",
    "League": "لیگ",
    "OK": "ٹھیک ہے",
    "VS": "بمقابلہ",
    "Username not found": "صارف نام نہیں ملا",
    "User not found": "صارف نہیں ملا",
    "Invalid betting percentage": "بیٹنگ کا فیصد غلط ہے"
  },
  "fa": {
    "No Bet Data": "اطلاعات شرط موجود نیست",
    "You Bet": "شرط شما",
    "Correct Score": "نتیجه دقیق",
    "Against Score": "نتیجه مخالف",
    "Processing...": "در حال پردازش...",
    "Please wait": "لطفاً صبر کنید",
    "Bet Placed Successfully": "شرط با موفقیت ثبت شد",
    "Amount": "مبلغ",
    "Bet ID": "شناسه شرط",
    "Match Date": "تاریخ مسابقه",
    "Kick-off Time": "زمان شروع",
    "Football": "فوتبال",
    "Home": "میزبان",
    "Loading balance...": "در حال بارگذاری موجودی...",
    "Please fill in the amount": "مبلغ را وارد کنید",
    "Minimum bet": "حداقل شرط",
    "for these odds": "برای این ضرایب",
    "Profit": "سود",
    "Gain": "برد کل",
    "Balance": "موجودی",
    "Loading...": "در حال بارگذاری...",
    "No available balance": "موجودی در دسترس نیست",
    "Cancel": "لغو",
    "Confirm": "تأیید",
    "ALL": "همه",
    "Amount settings": "تنظیمات مبلغ",
    "No available currency balance": "موجودی ارزی در دسترس نیست",
    "Enter valid amount": "مبلغ معتبر وارد کنید",
    "Invalid odds. Please return and select the bet again.": "ضرایب نامعتبر است. برگردید و شرط را دوباره انتخاب کنید.",
    "Insufficient balance": "موجودی کافی نیست",
    "Minimum bet for": "حداقل شرط برای",
    "is": "است",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "به محدودیت ۳ مسابقه متفاوت در روز رسیده‌اید. امروز نمی‌توانید مسابقه جدیدی اضافه کنید.",
    "Currency field not found": "فیلد ارز پیدا نشد",
    "Bet failed": "شرط ناموفق بود",
    "League": "لیگ",
    "OK": "تأیید",
    "VS": "در برابر",
    "Username not found": "نام کاربری پیدا نشد",
    "User not found": "کاربر پیدا نشد",
    "Invalid betting percentage": "درصد شرط نامعتبر است"
  },
  "ha": {
    "No Bet Data": "Babu bayanan fare",
    "You Bet": "Ka yi fare",
    "Correct Score": "Sakamako daidai",
    "Against Score": "Sakamakon kishiya",
    "Processing...": "Ana aiki...",
    "Please wait": "Da fatan za a jira",
    "Bet Placed Successfully": "An sanya fare cikin nasara",
    "Amount": "Adadi",
    "Bet ID": "ID na fare",
    "Match Date": "Ranar wasa",
    "Kick-off Time": "Lokacin farawa",
    "Football": "Kwallon kafa",
    "Home": "Gida",
    "Loading balance...": "Ana loda ma'auni...",
    "Please fill in the amount": "Shigar da adadi",
    "Minimum bet": "Mafi ƙarancin fare",
    "for these odds": "ga waɗannan odds",
    "Profit": "Riba",
    "Gain": "Jimillar nasara",
    "Balance": "Ma'auni",
    "Loading...": "Ana lodawa...",
    "No available balance": "Babu ma'auni da ake da shi",
    "Cancel": "Soke",
    "Confirm": "Tabbatar",
    "ALL": "DUKA",
    "Amount settings": "Saitunan adadi",
    "No available currency balance": "Babu ma'aunin kuɗi da ake da shi",
    "Enter valid amount": "Shigar da adadi mai inganci",
    "Invalid odds. Please return and select the bet again.": "Odds ba daidai ba ne. Koma ka sake zaɓar fare.",
    "Insufficient balance": "Ma'auni bai isa ba",
    "Minimum bet for": "Mafi ƙarancin fare na",
    "is": "shi ne",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Ka kai iyakar wasanni 3 daban a rana. Ba za ka iya ƙara sabon wasa yau ba.",
    "Currency field not found": "Ba a sami filin kuɗi ba",
    "Bet failed": "Fare ya gaza",
    "League": "Gasar",
    "OK": "To",
    "VS": "DA",
    "Username not found": "Ba a sami sunan mai amfani ba",
    "User not found": "Ba a sami mai amfani ba",
    "Invalid betting percentage": "Kashi na fare bai dace ba"
  },
  "yo": {
    "No Bet Data": "Ko si data tẹtẹ",
    "You Bet": "O tẹtẹ",
    "Correct Score": "Abajade deede",
    "Against Score": "Abajade alatako",
    "Processing...": "Ń ṣiṣẹ́...",
    "Please wait": "Jọ̀wọ́ dúró",
    "Bet Placed Successfully": "A ti fi tẹtẹ sílẹ̀ dáadáa",
    "Amount": "Iye",
    "Bet ID": "ID tẹtẹ",
    "Match Date": "Ọjọ́ eré",
    "Kick-off Time": "Àkókò ìbẹ̀rẹ̀",
    "Football": "Bọ́ọ̀lù",
    "Home": "Ilé",
    "Loading balance...": "Ń gba ìwọ̀ntúnwọ̀nsì...",
    "Please fill in the amount": "Tẹ iye sí i",
    "Minimum bet": "Tẹtẹ tó kéré jù",
    "for these odds": "fún odds wọ̀nyí",
    "Profit": "Èrè",
    "Gain": "Ìṣẹ́gun lápapọ̀",
    "Balance": "Ìwọ̀ntúnwọ̀nsì",
    "Loading...": "Ń gbé sókè...",
    "No available balance": "Kò sí ìwọ̀ntúnwọ̀nsì tó wà",
    "Cancel": "Fagilé",
    "Confirm": "Jẹ́rìí",
    "ALL": "GBOGBO",
    "Amount settings": "Ètò iye",
    "No available currency balance": "Kò sí ìwọ̀ntúnwọ̀nsì owó tó wà",
    "Enter valid amount": "Tẹ iye tó bófin mu",
    "Invalid odds. Please return and select the bet again.": "Odds kò tọ́. Padà kí o tún yan tẹtẹ náà.",
    "Insufficient balance": "Ìwọ̀ntúnwọ̀nsì kò tó",
    "Minimum bet for": "Tẹtẹ tó kéré jù fún",
    "is": "ni",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "O ti dé ààlà eré mẹ́ta ọ̀tọ̀ọ̀tọ̀ lójúmọ́. O kò lè fi eré tuntun kún un lónìí.",
    "Currency field not found": "A kò rí pápá owó",
    "Bet failed": "Tẹtẹ kuna",
    "League": "Ìdíje",
    "OK": "Ó dáa",
    "VS": "LÁÀRÍN",
    "Username not found": "A kò rí orúkọ olùlò",
    "User not found": "A kò rí olùlò",
    "Invalid betting percentage": "Ìpín tẹtẹ kò tọ́"
  },
  "zu": {
    "No Bet Data": "Ayikho idatha yokubheja",
    "You Bet": "Uyabheja",
    "Correct Score": "Amaphuzu alungile",
    "Against Score": "Amaphuzu aphikisayo",
    "Processing...": "Kuyacutshungulwa...",
    "Please wait": "Sicela ulinde",
    "Bet Placed Successfully": "Ukubheja kubekwe ngempumelelo",
    "Amount": "Inani",
    "Bet ID": "I-ID yokubheja",
    "Match Date": "Usuku lomdlalo",
    "Kick-off Time": "Isikhathi sokuqala",
    "Football": "Ibhola",
    "Home": "Ekhaya",
    "Loading balance...": "Kulayishwa ibhalansi...",
    "Please fill in the amount": "Faka inani",
    "Minimum bet": "Ukubheja okuncane",
    "for these odds": "kulawa ma-odds",
    "Profit": "Inzuzo",
    "Gain": "Okuwinile",
    "Balance": "Ibhalansi",
    "Loading...": "Kuyalayishwa...",
    "No available balance": "Ayikho ibhalansi etholakalayo",
    "Cancel": "Khansela",
    "Confirm": "Qinisekisa",
    "ALL": "KONKE",
    "Amount settings": "Izilungiselelo zenani",
    "No available currency balance": "Ayikho ibhalansi yemali etholakalayo",
    "Enter valid amount": "Faka inani elivumelekile",
    "Invalid odds. Please return and select the bet again.": "Ama-odds awavumelekile. Buyela emuva ukhethe ukubheja futhi.",
    "Insufficient balance": "Ibhalansi ayanele",
    "Minimum bet for": "Ukubheja okuncane kwe-",
    "is": "ngu",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Ufinyelele umkhawulo wemidlalo ehlukene engu-3 ngosuku. Awukwazi ukwengeza omunye umdlalo namuhla.",
    "Currency field not found": "Inkambu yemali ayitholakali",
    "Bet failed": "Ukubheja kwehlulekile",
    "League": "Iligi",
    "OK": "Kulungile",
    "VS": "NGOKUMELENE",
    "Username not found": "Igama lomsebenzisi alitholakali",
    "User not found": "Umsebenzisi akatholakali",
    "Invalid betting percentage": "Iphesenti lokubheja alivumelekile"
  },
  "am": {
    "No Bet Data": "የውርርድ መረጃ የለም",
    "You Bet": "ውርርድዎ",
    "Correct Score": "ትክክለኛ ውጤት",
    "Against Score": "ተቃራኒ ውጤት",
    "Processing...": "በሂደት ላይ...",
    "Please wait": "እባክዎ ይጠብቁ",
    "Bet Placed Successfully": "ውርርድ በተሳካ ሁኔታ ተደርጓል",
    "Amount": "መጠን",
    "Bet ID": "የውርርድ መለያ",
    "Match Date": "የጨዋታ ቀን",
    "Kick-off Time": "የመጀመሪያ ሰዓት",
    "Football": "እግር ኳስ",
    "Home": "ቤት",
    "Loading balance...": "ቀሪ ሂሳብ በመጫን ላይ...",
    "Please fill in the amount": "መጠኑን ያስገቡ",
    "Minimum bet": "ዝቅተኛ ውርርድ",
    "for these odds": "ለእነዚህ ዕድሎች",
    "Profit": "ትርፍ",
    "Gain": "ጠቅላላ ድል",
    "Balance": "ቀሪ ሂሳብ",
    "Loading...": "በመጫን ላይ...",
    "No available balance": "የሚገኝ ቀሪ ሂሳብ የለም",
    "Cancel": "ሰርዝ",
    "Confirm": "አረጋግጥ",
    "ALL": "ሁሉም",
    "Amount settings": "የመጠን ቅንብሮች",
    "No available currency balance": "የሚገኝ የምንዛሬ ቀሪ ሂሳብ የለም",
    "Enter valid amount": "ትክክለኛ መጠን ያስገቡ",
    "Invalid odds. Please return and select the bet again.": "የዕድል መጠኖች ልክ አይደሉም። ተመለስና ውርርዱን እንደገና ምረጥ።",
    "Insufficient balance": "ቀሪ ሂሳብ በቂ አይደለም",
    "Minimum bet for": "ዝቅተኛ ውርርድ ለ",
    "is": "ነው",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "በቀን 3 የተለያዩ ጨዋታዎች ገደብ ደርሰዋል። ዛሬ አዲስ ጨዋታ ማከል አይችሉም።",
    "Currency field not found": "የምንዛሬ መስክ አልተገኘም",
    "Bet failed": "ውርርድ አልተሳካም",
    "League": "ሊግ",
    "OK": "እሺ",
    "VS": "ከ",
    "Username not found": "የተጠቃሚ ስም አልተገኘም",
    "User not found": "ተጠቃሚው አልተገኘም",
    "Invalid betting percentage": "የውርርድ መቶኛ ትክክል አይደለም"
  },
  "so": {
    "No Bet Data": "Xogta sharadka ma jirto",
    "You Bet": "Waad sharadaysaa",
    "Correct Score": "Natiijo sax ah",
    "Against Score": "Natiijo lid ah",
    "Processing...": "Waa la shaqaynayaa...",
    "Please wait": "Fadlan sug",
    "Bet Placed Successfully": "Sharadka si guul leh ayaa loo dhigay",
    "Amount": "Qaddar",
    "Bet ID": "Aqoonsiga sharadka",
    "Match Date": "Taariikhda ciyaarta",
    "Kick-off Time": "Waqtiga bilowga",
    "Football": "Kubadda cagta",
    "Home": "Guriga",
    "Loading balance...": "Hadhaaga waa la rarayaa...",
    "Please fill in the amount": "Geli qaddarka",
    "Minimum bet": "Sharadka ugu yar",
    "for these odds": "odds-kan",
    "Profit": "Faa'iido",
    "Gain": "Guul guud",
    "Balance": "Hadhaag",
    "Loading...": "Waa la rarayaa...",
    "No available balance": "Hadhaag la heli karo ma jiro",
    "Cancel": "Jooji",
    "Confirm": "Xaqiiji",
    "ALL": "DHAMMAAN",
    "Amount settings": "Dejinta qaddarka",
    "No available currency balance": "Hadhaag lacag ah oo la heli karo ma jiro",
    "Enter valid amount": "Geli qaddar sax ah",
    "Invalid odds. Please return and select the bet again.": "Odds khaldan. Dib u noqo oo mar kale dooro sharadka.",
    "Insufficient balance": "Hadhaag kuma filna",
    "Minimum bet for": "Sharadka ugu yar ee",
    "is": "waa",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Waxaad gaartay xadka 3 ciyaarood oo kala duwan maalintii. Maanta ciyaar cusub kuma dari kartid.",
    "Currency field not found": "Goobta lacagta lama helin",
    "Bet failed": "Sharadku wuu fashilmay",
    "League": "Horyaal",
    "OK": "Hagaag",
    "VS": "IYO",
    "Username not found": "Magaca isticmaalaha lama helin",
    "User not found": "Isticmaale lama helin",
    "Invalid betting percentage": "Boqolkiiba sharadku sax ma aha"
  },
  "rw": {
    "No Bet Data": "Nta makuru y’urusimbi",
    "You Bet": "Uteye urusimbi",
    "Correct Score": "Amanota nyayo",
    "Against Score": "Amanota ahanganye",
    "Processing...": "Birakorwa...",
    "Please wait": "Tegereza gato",
    "Bet Placed Successfully": "Urusimbi rwashyizweho neza",
    "Amount": "Umubare",
    "Bet ID": "Indangamuntu y’urusimbi",
    "Match Date": "Itariki y’umukino",
    "Kick-off Time": "Igihe cyo gutangira",
    "Football": "Umupira w’amaguru",
    "Home": "Mu rugo",
    "Loading balance...": "Amafaranga ari kwinjizwa...",
    "Please fill in the amount": "Andika umubare",
    "Minimum bet": "Urusimbi ntarengwa",
    "for these odds": "kuri aya mahirwe",
    "Profit": "Inyungu",
    "Gain": "Ibyo utsinda",
    "Balance": "Amafaranga asigaye",
    "Loading...": "Birimo...",
    "No available balance": "Nta mafaranga ahari",
    "Cancel": "Hagarika",
    "Confirm": "Emeza",
    "ALL": "BYOSE",
    "Amount settings": "Igenamiterere ry’umubare",
    "No available currency balance": "Nta mafaranga y’ifaranga ahari",
    "Enter valid amount": "Andika umubare wemewe",
    "Invalid odds. Please return and select the bet again.": "Amahirwe si yo. Subira inyuma wongere uhitemo urusimbi.",
    "Insufficient balance": "Amafaranga ntahagije",
    "Minimum bet for": "Urusimbi ntarengwa rwa",
    "is": "ni",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Wageze ku mupaka w’imikino 3 itandukanye ku munsi. Ntushobora kongeraho undi mukino uyu munsi.",
    "Currency field not found": "Umwanya w’ifaranga ntubonetse",
    "Bet failed": "Urusimbi rwanze",
    "League": "Shampiyona",
    "OK": "Sawa",
    "VS": "NA",
    "Username not found": "Izina ry’ukoresha ntiriboneka",
    "User not found": "Ukoresha ntabonetse",
    "Invalid betting percentage": "Ijanisha ry’urusimbi si ryo"
  },
  "lg": {
    "No Bet Data": "Tewali data ya kubetinga",
    "You Bet": "Obeera",
    "Correct Score": "Score entuufu",
    "Against Score": "Score ey’okuvuganya",
    "Processing...": "Kikolebwa...",
    "Please wait": "Nsaba olindeko",
    "Bet Placed Successfully": "Okubetinga kuteekeddwawo bulungi",
    "Amount": "Omuwendo",
    "Bet ID": "Bet ID",
    "Match Date": "Olunaku lw’omupiira",
    "Kick-off Time": "Essaawa y’okutandika",
    "Football": "Omupiira",
    "Home": "Awaka",
    "Loading balance...": "Balance etikkibwa...",
    "Please fill in the amount": "Yingiza omuwendo",
    "Minimum bet": "Bet entono esinga",
    "for these odds": "ku odds zino",
    "Profit": "Amagoba",
    "Gain": "Omuwendo gw’obuwanguzi",
    "Balance": "Balance",
    "Loading...": "Kittikkibwa...",
    "No available balance": "Tewali balance eriwo",
    "Cancel": "Sazaamu",
    "Confirm": "Kakasa",
    "ALL": "BYONNA",
    "Amount settings": "Enteekateeka z’omuwendo",
    "No available currency balance": "Tewali balance ya ssente eriwo",
    "Enter valid amount": "Yingiza omuwendo omutuufu",
    "Invalid odds. Please return and select the bet again.": "Odds si ntuufu. Ddayo olonde bet nate.",
    "Insufficient balance": "Balance temala",
    "Minimum bet for": "Bet entono ku",
    "is": "ye",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Otuuse ku kkomo lya mizannyo 3 egy’enjawulo buli lunaku. Tosobola kugattako muzannyo mupya leero.",
    "Currency field not found": "Ekifo ky’ensimbi tekizuuliddwa",
    "Bet failed": "Bet eremereddwa",
    "League": "Liigi",
    "OK": "Kale",
    "VS": "OKUVUGANYA",
    "Username not found": "Erinnya ly’omukozesa terirabise",
    "User not found": "Omukozesa talabise",
    "Invalid betting percentage": "Ebitundu by’obubeti si bituufu"
  },
  "af": {
    "No Bet Data": "Geen weddata",
    "You Bet": "Jy wed",
    "Correct Score": "Korrekte telling",
    "Against Score": "Teen-telling",
    "Processing...": "Verwerk tans...",
    "Please wait": "Wag asseblief",
    "Bet Placed Successfully": "Wed suksesvol geplaas",
    "Amount": "Bedrag",
    "Bet ID": "Wed-ID",
    "Match Date": "Wedstryddatum",
    "Kick-off Time": "Afskoptyd",
    "Football": "Sokker",
    "Home": "Tuis",
    "Loading balance...": "Saldo laai...",
    "Please fill in the amount": "Vul die bedrag in",
    "Minimum bet": "Minimum weddenskap",
    "for these odds": "vir hierdie kans",
    "Profit": "Wins",
    "Gain": "Totale wins",
    "Balance": "Saldo",
    "Loading...": "Laai...",
    "No available balance": "Geen beskikbare saldo",
    "Cancel": "Kanselleer",
    "Confirm": "Bevestig",
    "ALL": "ALLES",
    "Amount settings": "Bedraginstellings",
    "No available currency balance": "Geen beskikbare valutasaldo",
    "Enter valid amount": "Voer ’n geldige bedrag in",
    "Invalid odds. Please return and select the bet again.": "Ongeldige kans. Gaan terug en kies die weddenskap weer.",
    "Insufficient balance": "Onvoldoende saldo",
    "Minimum bet for": "Minimum weddenskap vir",
    "is": "is",
    "You have reached the limit of 3 different matches per day. You cannot add a new match today.": "Jy het die limiet van 3 verskillende wedstryde per dag bereik. Jy kan vandag nie ’n nuwe wedstryd byvoeg nie.",
    "Currency field not found": "Valutaveld nie gevind nie",
    "Bet failed": "Wed misluk",
    "League": "Liga",
    "OK": "OK",
    "VS": "TEEN",
    "Username not found": "Gebruikersnaam nie gevind nie",
    "User not found": "Gebruiker nie gevind nie",
    "Invalid betting percentage": "Ongeldige weddenskapspersentasie"
  }
};

const translateBetPlace = (text, language) => {
  const lang = BETPLACE_TRANSLATIONS[language]
    ? language
    : (BETPLACE_TRANSLATIONS[String(language || "en").split("-")[0]]
      ? String(language || "en").split("-")[0]
      : "en");
  return BETPLACE_TRANSLATIONS[lang]?.[text] || text;
};



// Start and end of today's calendar day in Tanzania (UTC+3).
const getTanzaniaDayBounds = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());

  const values = Object.fromEntries(
    parts.map((part) => [part.type, part.value])
  );

  const start = new Date(
    `${values.year}-${values.month}-${values.day}T00:00:00+03:00`
  );
  const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);

  return { start, end };
};

// ==========================================
// MINIMUM BET
// ==========================================

const MINIMUMS = {
  TZS: 10000,
  USDT: 5,
  KES: 900,
  UGX: 25500,
  RWF: 10500,
  BIF: 21000,
  ZMW: 135,
  MWK: 14000,
  MZN: 450,
  USD: 7,
  SSP: 42500,
  BWP: 94,
  MGA: 2900,
};

// Minimum TZS stake based on selected odds.
// Other currencies continue using the existing MINIMUMS above.
const getMinimumBet = (currency, odds) => {
  if (currency !== "TZS") {
    return MINIMUMS[currency] || 0;
  }

  const value = Number(odds);
  if (!Number.isFinite(value)) return MINIMUMS.TZS;

  if (value >= 9 && value < 10) return 100000000;
  if (value >= 8 && value < 9) return 50000000;
  if (value >= 7 && value < 8) return 10000000;
  if (value >= 6 && value < 7) return 4000000;
  if (value >= 5 && value < 6) return 2000000;
  if (value >= 4 && value < 5) return 1000000;

  return MINIMUMS.TZS;
};

// ==========================================
// FIRESTORE BALANCE FIELDS
// ==========================================

const fieldMap = {
  TZS: "tshBalance",
  USDT: "usdtBalance",
  KES: "KESBalance",
  UGX: "UGXBalance",
  RWF: "RWFBalance",
  BIF: "BIFBalance",
  ZMW: "ZMWBalance",
  MWK: "MWKBalance",
  MZN: "MZNBalance",
  USD: "USDBalance",
  SSP: "SSPBalance",
  BWP: "BWPBalance",
  MGA: "MGABalance",
};

// ==========================================
// HELPERS
// ==========================================

const getNumericOdds = (odds) => {
  if (
    odds === undefined ||
    odds === null ||
    odds === ""
  ) {
    return 0;
  }

  const numericValue = Number(
    String(odds)
      .replace("%", "")
      .trim()
  );

  if (!Number.isFinite(numericValue)) {
    return 0;
  }

  return numericValue;
};

// ==========================================
// MAIN COMPONENT
// ==========================================

export default function BetPlace() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const match = state?.match;
  const selection = state?.selection;

  const { setBalances } = useBalance();
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );
  const t = (text) => translateBetPlace(text, language);

  useEffect(() => {
    const syncLanguage = (event) => {
      const nextLanguage =
        event?.detail?.language ||
        event?.detail ||
        localStorage.getItem("language") ||
        "en";
      setLanguage(String(nextLanguage));
    };
    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncLanguage);
    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);


  const [amount, setAmount] = useState("");
  const [activeCurrency, setActiveCurrency] = useState(null);
  const [firestoreBalances, setFirestoreBalances] = useState({});
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [betSuccess, setBetSuccess] = useState(null);

  // ==========================================
  // LOAD USER BALANCES
  // ==========================================

  useEffect(() => {
    let isMounted = true;

    const loadUserBalances = async () => {
      try {
        setBalanceLoading(true);

        const username = localStorage.getItem("username");

        if (!username) {
          console.error("Username haipo localStorage");

          if (isMounted) {
            setFirestoreBalances({});
          }

          return;
        }

        const userQuery = query(
          collection(db, "users"),
          where("username", "==", username)
        );

        const snapshot = await getDocs(userQuery);

        if (snapshot.empty) {
          console.error("User hajapatikana:", username);

          if (isMounted) {
            setFirestoreBalances({});
          }

          return;
        }

        const userData = snapshot.docs[0].data();
        const loadedBalances = {};

        Object.entries(fieldMap).forEach(
          ([currency, firebaseField]) => {
            loadedBalances[currency] = Number(
              userData[firebaseField] || 0
            );
          }
        );

        if (isMounted) {
          setFirestoreBalances(loadedBalances);

          if (typeof setBalances === "function") {
            setBalances((previous) => ({
              ...(previous || {}),
              ...loadedBalances,
            }));
          }
        }
      } catch (error) {
        console.error("Balance load error:", error);

        if (isMounted) {
          setFirestoreBalances({});
        }
      } finally {
        if (isMounted) {
          setBalanceLoading(false);
        }
      }
    };

    loadUserBalances();

    return () => {
      isMounted = false;
    };
  }, [setBalances]);

  // ==========================================
  // AVAILABLE CURRENCIES
  // ==========================================

  const availableCurrencies = useMemo(() => {
    return Object.entries(firestoreBalances)
      .filter(([, balance]) => Number(balance || 0) > 0)
      .map(([currency, balance]) => ({
        currency,
        balance: Number(balance || 0),
      }));
  }, [firestoreBalances]);

  const showCurrencySelect =
    availableCurrencies.length > 1;

  // ==========================================
  // DEFAULT CURRENCY
  // ==========================================

  useEffect(() => {
    if (balanceLoading) {
      return;
    }

    if (availableCurrencies.length === 0) {
      setActiveCurrency(null);
      return;
    }

    const currencyStillAvailable =
      availableCurrencies.some(
        (item) => item.currency === activeCurrency
      );

    if (!currencyStillAvailable) {
      setActiveCurrency(
        availableCurrencies[0].currency
      );
    }
  }, [
    availableCurrencies,
    activeCurrency,
    balanceLoading,
  ]);

  // ==========================================
  // NO BET DATA
  // ==========================================

  if (!match || !selection) {
    return (
      <div className="betplace-empty">
        No Bet Data
      </div>
    );
  }

  // ==========================================
  // CURRENT BALANCE
  // ==========================================

  const currentBalance = activeCurrency
    ? Number(
        firestoreBalances[activeCurrency] || 0
      )
    : 0;

  // ==========================================
  // BET MODE
  // ==========================================

  const isCorrectScore =
    selection?.mode === "correct";

  // ==========================================
  // ODDS FROM BETSCORES
  // ==========================================

  /**
   * Correct Score haitumii tena:
   * 25%, 35%, au 50%.
   *
   * Inatumia odds zilizotumwa ndani ya:
   * selection.odds
   */
  const percent = getNumericOdds(
    selection?.odds
  );

  // ==========================================
  // CALCULATIONS
  // ==========================================

  const numericAmount = Number(amount || 0);
  const numericOdds = Number(percent || 0);

  const calculatedProfit =
    numericAmount > 0 && numericOdds > 0
      ? (numericAmount * numericOdds) / 100
      : 0;

  const totalWin =
    numericAmount + calculatedProfit;

  // ==========================================
  // FORMAT MONEY
  // ==========================================

  const formatMoney = (value) => {
    const number = Number(value || 0);

    if (!Number.isFinite(number)) {
      return "0.00";
    }

    return number.toLocaleString("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ==========================================
  // PARSE MATCH DATE
  // ==========================================

  const parseMatchDate = (date, time) => {
    if (!date) {
      return null;
    }

    if (typeof date?.toDate === "function") {
      return date.toDate();
    }

    if (date instanceof Date) {
      return date;
    }

    const dateString = String(date).trim();

    const timeString = time
      ? String(time).trim()
      : "00:00";

    if (
      dateString.includes("T") ||
      dateString.includes(" ")
    ) {
      const existing = new Date(
        dateString.replace(" ", "T")
      );

      if (
        Number.isFinite(
          existing.getTime()
        )
      ) {
        return existing;
      }
    }

    const eatDateTime = new Date(
      `${dateString}T${timeString}:00+03:00`
    );

    if (
      Number.isFinite(
        eatDateTime.getTime()
      )
    ) {
      return eatDateTime;
    }

    return null;
  };

  const matchDateObj =
    parseMatchDate(
      match.date,
      match.time
    ) || new Date();

  // ==========================================
  // FORMAT DATE EAT
  // ==========================================

  const formatDateEAT = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: TIMEZONE,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  // ==========================================
  // FORMAT TIME EAT
  // ==========================================

  const formatTimeEAT = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: TIMEZONE,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const formattedDate =
    formatDateEAT(matchDateObj);

  const formattedTime =
    formatTimeEAT(matchDateObj);

  // ==========================================
  // QUICK AMOUNTS
  // ==========================================

  const getQuickAmounts = () => {
    const minimum =
      MINIMUMS[activeCurrency] || 1;

    return [
      minimum * 3,
      minimum * 10,
      minimum * 30,
    ];
  };

  // ==========================================
  // BET ID
  // ==========================================

  const generateBetId = () => {
    const letters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    const numbers =
      "0123456789";

    const letterPart = Array.from(
      { length: 4 },
      () =>
        letters.charAt(
          Math.floor(
            Math.random() *
              letters.length
          )
        )
    );

    const numberPart = Array.from(
      { length: 16 },
      () =>
        numbers.charAt(
          Math.floor(
            Math.random() *
              numbers.length
          )
        )
    );

    const combined = [
      ...letterPart,
      ...numberPart,
    ];

    for (
      let i = combined.length - 1;
      i > 0;
      i--
    ) {
      const j = Math.floor(
        Math.random() * (i + 1)
      );

      [combined[i], combined[j]] = [
        combined[j],
        combined[i],
      ];
    }

    return combined.join("");
  };

  // ==========================================
  // TEAMS
  // ==========================================

  const teamA =
    match.A ||
    match.teamA ||
    "";

  const teamB =
    match.B ||
    match.teamB ||
    "";

  // ==========================================
  // HOME TEAM
  // ==========================================

  const homeTeam =
    match.homeTeam || "";

  const isTeamAHome =
    homeTeam &&
    teamA &&
    String(homeTeam).trim() ===
      String(teamA).trim();

  const isTeamBHome =
    homeTeam &&
    teamB &&
    String(homeTeam).trim() ===
      String(teamB).trim();

  // ==========================================
  // HANDLE BET
  // ==========================================

  const handleBet = async () => {
    if (loading) {
      return;
    }

    const betAmount = Number(amount);

    // ========================================
    // CURRENCY CHECK
    // ========================================

    if (!activeCurrency) {
      alert(t("No available currency balance"));
      return;
    }

    // ========================================
    // AMOUNT CHECK
    // ========================================

    if (
      !Number.isFinite(betAmount) ||
      betAmount <= 0
    ) {
      alert(t("Enter valid amount"));
      return;
    }

    // ========================================
    // ODDS CHECK
    // ========================================

    if (
      !Number.isFinite(percent) ||
      percent <= 0
    ) {
      alert(
        t("Invalid odds. Please return and select the bet again.")
      );

      return;
    }

    // ========================================
    // MINIMUM BET
    // ========================================

    const minimum = getMinimumBet(
      activeCurrency,
      percent
    );

    if (betAmount < minimum) {
      alert(`${t("Minimum bet for")} ${activeCurrency} ${t("is")} ${minimum.toLocaleString("en-GB")}`);

      return;
    }

    // ========================================
    // LOCAL BALANCE CHECK
    // ========================================

    if (betAmount > currentBalance) {
      alert(t("Insufficient balance"));
      return;
    }

    try {
      setLoading(true);
      setShowSpinner(true);

      // ======================================
      // USERNAME
      // ======================================

      const username =
        localStorage.getItem("username");

      if (!username) {
        throw new Error(t("Username not found"));
      }

      // ======================================
      // GET FRESH USER DATA
      // ======================================

      const userQuery = query(
        collection(db, "users"),
        where("username", "==", username)
      );

      const snapshot =
        await getDocs(userQuery);

      if (snapshot.empty) {
        throw new Error(t("User not found"));
      }

      const userDoc =
        snapshot.docs[0];

      const userData =
        userDoc.data();

      const userRef = doc(
        db,
        "users",
        userDoc.id
      );

      // ======================================
      // KO USER
      // ======================================

      const isKOUser =
        userData.KO === "YES";

      // ======================================
      // DAILY UNIQUE MATCH LIMIT (3 MATCHES)
      // SO === "YES" USERS ARE EXEMPT
      // ======================================

      if (userData.SO !== "YES") {
        const { start, end } = getTanzaniaDayBounds();

        // Query by username only to avoid requiring a composite Firestore index.
        const getUserBetsForToday = async (collectionName) => {
          const betsQuery = query(
            collection(db, collectionName),
            where("username", "==", username)
          );

          const snapshot = await getDocs(betsQuery);

          return snapshot.docs.filter((betDoc) => {
            const createdAt = betDoc.data().createdAt;

            if (!createdAt || typeof createdAt.toDate !== "function") {
              return false;
            }

            const createdAtDate = createdAt.toDate();
            return createdAtDate >= start && createdAtDate < end;
          });
        };

        const [antScoreDocs, correctScoreDocs] = await Promise.all([
          getUserBetsForToday("antscore"),
          getUserBetsForToday("correctscore"),
        ]);

        const uniqueMatchKeys = new Set();

        [...antScoreDocs, ...correctScoreDocs].forEach((betDoc) => {
          const bet = betDoc.data();
          const matchKey = bet.matchId
            ? `id:${String(bet.matchId)}`
            : `teams:${String(bet.teamA || "").trim().toLowerCase()}|${String(
                bet.teamB || ""
              ).trim().toLowerCase()}|${String(
                bet.matchDate || ""
              )}|${String(bet.matchTime || "")}|${String(
                bet.league || ""
              ).trim().toLowerCase()}`;

          if (bet.matchId || bet.teamA || bet.teamB || bet.matchDate) {
            uniqueMatchKeys.add(matchKey);
          }
        });

        const currentMatchId = match.id || match.sofaId || "";

        const currentMatchKey = currentMatchId
          ? `id:${String(currentMatchId)}`
          : `teams:${String(teamA).trim().toLowerCase()}|${String(
              teamB
            ).trim().toLowerCase()}|${String(
              match.date ? String(match.date) : ""
            )}|${String(match.time ? String(match.time) : "")}|${String(
              match.league || ""
            ).trim().toLowerCase()}`;

        const isSameMatchAlreadyCounted =
          uniqueMatchKeys.has(currentMatchKey);

        if (
          uniqueMatchKeys.size >= 3 &&
          !isSameMatchAlreadyCounted
        ) {
          throw new Error(
            t("You have reached the limit of 3 different matches per day. You cannot add a new match today.")
          );
        }
      }

      // ======================================
      // BALANCE FIELD
      // ======================================

      const field =
        fieldMap[activeCurrency];

      if (!field) {
        throw new Error(
          t("Currency field not found")
        );
      }

      // ======================================
      // FRESH FIRESTORE BALANCE
      // ======================================

      const firebaseBalance =
        Number(
          userData[field] || 0
        );

      if (betAmount > firebaseBalance) {
        setFirestoreBalances(
          (previous) => ({
            ...previous,
            [activeCurrency]:
              firebaseBalance,
          })
        );

        throw new Error(
          t("Insufficient balance")
        );
      }

      // ======================================
      // FINAL PERCENT
      // ======================================

      /**
       * Correct Score:
       * Inatumia selection.odds kutoka BetScores.
       *
       * Non-Correct Score kwa KO user:
       * Inatumia 25% kama business rule.
       */
      const finalPercent =
        isKOUser && !isCorrectScore
          ? 25
          : Number(percent);

      if (
        !Number.isFinite(finalPercent) ||
        finalPercent <= 0
      ) {
        throw new Error(t("Invalid betting percentage"));
      }

      // ======================================
      // FINAL PROFIT
      // ======================================

      const finalProfit =
        (betAmount * finalPercent) / 100;

      const finalTotalWin =
        betAmount + finalProfit;

      // ======================================
      // BET ID
      // ======================================

      const betId = generateBetId();

      // ======================================
      // MATCH DATE OBJECT
      // ======================================

      const safeMatchDateObj =
        parseMatchDate(
          match.date,
          match.time
        ) || new Date();

      // ======================================
      // MATCH ID
      // ======================================

      const matchId =
        match.id ||
        match.sofaId ||
        "";

      // ======================================
      // MATCH DATE / TIME
      // ======================================

      const savedMatchDate =
        match.date
          ? String(match.date)
          : "";

      const savedMatchTime =
        match.time
          ? String(match.time)
          : "";

      // ======================================
      // BET DATA
      // ==========================================

      const betData = {
        betId,
        username,
        matchId,

        teamA,
        teamB,
        homeTeam: homeTeam || "",

        league: match.league || "",
        country: match.country || "",

        score: selection.score,
        odds: finalPercent,
        mode: selection.mode || "",

        amount: betAmount,
        stake: betAmount,
        quantity: betAmount,

        profit: finalProfit,
        totalWin: finalTotalWin,
        currency: activeCurrency,

        matchDate: savedMatchDate,
        matchTime: savedMatchTime,

        matchTimestamp:
          Timestamp.fromDate(
            safeMatchDateObj
          ),

        matchDateText:
          savedMatchDate,

        type:
          isKOUser || isCorrectScore
            ? "correctscore"
            : "antscore",

        status: "pending",
        createdAt: serverTimestamp(),
      };

      // ======================================
      // COLLECTION
      // ======================================

      const collectionName =
        isKOUser || isCorrectScore
          ? "correctscore"
          : "antscore";

      // ======================================
      // SAVE BET
      // ======================================

      await addDoc(
        collection(
          db,
          collectionName
        ),
        betData
      );

      // ======================================
      // NEW BALANCE
      // ======================================

      const newBalance =
        firebaseBalance - betAmount;

      // ======================================
      // UPDATE FIRESTORE BALANCE
      // ======================================

      await updateDoc(userRef, {
        [field]: newBalance,
      });

      // ======================================
      // UPDATE LOCAL BALANCE
      // ======================================

      setFirestoreBalances(
        (previous) => ({
          ...previous,
          [activeCurrency]:
            newBalance,
        })
      );

      // ======================================
      // UPDATE BALANCE CONTEXT
      // ======================================

      if (
        typeof setBalances === "function"
      ) {
        setBalances((previous) => ({
          ...(previous || {}),

          [activeCurrency]:
            newBalance,

          [field]: newBalance,
        }));
      }

      // ======================================
      // SUCCESS DELAY
      // ======================================

      await new Promise((resolve) => {
        setTimeout(resolve, 3000);
      });

      // ======================================
      // SUCCESS MODAL
      // ======================================

      setShowSpinner(false);

      setBetSuccess({
        betId,
        amount: betAmount,
        currency: activeCurrency,
        matchDate: safeMatchDateObj,
      });

      setLoading(false);
      setAmount("");
    } catch (error) {
      console.error(
        "BET ERROR:",
        error
      );

      setShowSpinner(false);
      setLoading(false);

      alert(
        t(error?.message || "Bet failed")
      );
    }
  };

  // ==========================================
  // UI
  // ==========================================

  return (
    <div className="betplace">
      {/* ======================================
          PROCESSING
      ====================================== */}

      {showSpinner && (
        <div className="order-result-overlay">
          <div className="order-result-sheet">
            <div className="order-processing">
              <div className="processing-spinner" />

              <h2>{t("Processing...")}</h2>

              <p>{t("Please wait")}</p>
            </div>
          </div>
        </div>
      )}

      {/* ======================================
          SUCCESS
      ====================================== */}

      {betSuccess && (
        <div className="order-result-overlay">
          <div className="order-result-sheet">
            <div className="order-success">
              <div className="success-check">
                ✓
              </div>

              <h2>
                Bet Placed Successfully
              </h2>

              <div className="bet-success-info">
                <div>
                  <span>{t("Amount")}</span>

                  <strong>
                    {betSuccess.currency}{" "}
                    {betSuccess.amount.toLocaleString(
                      "en-GB"
                    )}
                  </strong>
                </div>

                <div>
                  <span>{t("Bet ID")}</span>

                  <strong>
                    {betSuccess.betId}
                  </strong>
                </div>

                <div>
                  <span>{t("Match Date")}</span>

                  <strong>
                    {formatDateEAT(
                      betSuccess.matchDate
                    )}
                  </strong>
                </div>

                <div>
                  <span>
                    {t("Kick-off Time")}
                  </span>

                  <strong>
                    {formatTimeEAT(
                      betSuccess.matchDate
                    )}
                  </strong>
                </div>
              </div>

              <button
                type="button"
                className="order-result-ok"
                onClick={() => {
                  setBetSuccess(null);
                  navigate(-1);
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ======================================
          BET CARD
      ====================================== */}

      <div className="betplace-card">
        <div className="betplace-handle" />

        <div className="betplace-you-bet">
          {t("You Bet")}
        </div>

        <div className="betplace-selection-title">
          {isCorrectScore
            ? "Correct Score"
            : "Against Score"}{" "}
          {selection.score}
        </div>

        <div className="betplace-league">
          {"{ "}

          {match.country
            ? `${match.country}: `
            : ""}

          {match.league || t("League")}

          {" }"}
        </div>

        {/* TEAMS */}

        <div className="betplace-teams">
          <div className="betplace-team">
            <div
              className="betplace-football"
              aria-label={t("Football")}
            >
              ⚽
            </div>

            <strong>
              {teamA}
            </strong>

            {isTeamAHome && (
              <small>
                (Home)
              </small>
            )}
          </div>

          <div className="betplace-vs">
            VS
          </div>

          <div className="betplace-team">
            <div
              className="betplace-football"
              aria-label={t("Football")}
            >
              ⚽
            </div>

            <strong>
              {teamB}
            </strong>

            {isTeamBHome && (
              <small>
                (Home)
              </small>
            )}
          </div>
        </div>

        {/* DATE */}

        <div className="betplace-date">
          {formattedDate}{" "}
          {formattedTime}
        </div>

        {/* BALANCE LOADING */}

        {balanceLoading && (
          <div className="betplace-balance-loading">
            Loading balance...
          </div>
        )}

        {/* CALCULATION */}

        <div className="betplace-calc">
          <div className="betplace-calc-col">
            <div className="betplace-calc-label">
              Amount
            </div>

            <div className="betplace-input-wrap">
              <input
                type="number"
                min="0"
                step="any"
                inputMode="decimal"
                placeholder={t("Please fill in the amount")}
                value={amount}
                onChange={(e) => {
                  setAmount(
                    e.target.value
                  );
                }}
              />

              {showCurrencySelect ? (
                <select
                  className="betplace-currency-select"
                  value={
                    activeCurrency || ""
                  }
                  onChange={(e) => {
                    setActiveCurrency(
                      e.target.value
                    );

                    setAmount("");
                  }}
                >
                  {availableCurrencies.map(
                    (item) => (
                      <option
                        key={item.currency}
                        value={item.currency}
                      >
                        {item.currency}
                      </option>
                    )
                  )}
                </select>
              ) : (
                <div className="betplace-single-currency">
                  {activeCurrency || "-"}
                </div>
              )}
            </div>
            {activeCurrency === "TZS" && Number(percent) >= 4 && (
              <small className="betplace-minimum-note">
                {t("Minimum bet")}: TZS {formatMoney(
                  getMinimumBet(activeCurrency, percent)
                )} {t("for these odds")}
              </small>
            )}
          </div>

          {/* PROFIT */}

          <div className="betplace-calc-col betplace-profit-col">
            <div className="betplace-calc-label">
              Profit
            </div>

            <div className="betplace-profit-value">
              × {numericOdds}%
            </div>

            <small>
              {activeCurrency || ""}{" "}
              {formatMoney(
                calculatedProfit
              )}
            </small>
          </div>

          {/* GAIN */}

          <div className="betplace-calc-col">
            <div className="betplace-calc-label">
              Gain
            </div>

            <div className="betplace-gain-value">
              {activeCurrency || "-"}{" "}
              {formatMoney(totalWin)}
            </div>
          </div>
        </div>

        {/* QUICK AMOUNTS */}

        <div className="betplace-quick">
          {getQuickAmounts().map(
            (quickAmount) => (
              <button
                type="button"
                key={quickAmount}
                disabled={
                  !activeCurrency ||
                  balanceLoading
                }
                onClick={() => {
                  setAmount(
                    String(quickAmount)
                  );
                }}
              >
                +
                {quickAmount.toLocaleString(
                  "en-GB"
                )}
              </button>
            )
          )}

          <button
            type="button"
            className="betplace-all"
            disabled={
              !activeCurrency ||
              balanceLoading
            }
            onClick={() => {
              setAmount(
                String(currentBalance)
              );
            }}
          >
            ALL
          </button>

          <button
            type="button"
            className="betplace-settings"
            title={t("Amount settings")}
            onClick={() => {
              setAmount("");
            }}
          >
            ⚙️
          </button>
        </div>

        {/* BALANCE */}

        <div className="betplace-balance">
          <span>
            Balance
          </span>

          <strong>
            {balanceLoading
              ? t("Loading...")
              : `${activeCurrency || "-"} ${formatMoney(
                  currentBalance
                )}`}
          </strong>
        </div>

        {/* NO BALANCE */}

        {!balanceLoading &&
          availableCurrencies.length === 0 && (
            <div className="betplace-no-balance">
              No available balance
            </div>
          )}

        {/* ACTIONS */}

        <div className="betplace-actions">
          <button
            type="button"
            className="betplace-cancel"
            disabled={loading}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            className="betplace-confirm"
            disabled={
              loading ||
              balanceLoading ||
              !numericAmount ||
              numericAmount <= 0 ||
              !activeCurrency ||
              percent <= 0
            }
            onClick={handleBet}
          >
            {loading
              ? "Processing..."
              : t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}